module.exports = __webpack_public_path__ + "static/media/0003.3c9a61c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48010/RAL/0003.png
// module id = 417
// module chunks = 0